module.exports = require("./nn-NO.js");